








































































































import Vue from 'vue'
import { columns } from './components/data'
import AddCard from './components/AddCard.vue'
import EditCard from './components/EditCard.vue'
import AppSelect from '../../../../components/AppSelect/index.vue'
import { DictServiceProxy, AppServiceProxy, AppCardServiceProxy  } from '@/service-proxies/app-v2/system.service-proxies'

const dictService = new DictServiceProxy()
const serviceProxy = new AppCardServiceProxy()
const appServiceProxy = new AppServiceProxy()

export default Vue.extend({
  name: 'index',
  components: {
    AddCard,
    AppSelect,
    EditCard
  },
  data() {
    return {
      columns, // 表单配置
      data: [], // 表单数据
      loading: false, // 表单加载状态
      totalContent: 0, // 表单列表数
      filter: {
        // 查询条件
        size: 30,
        current: 1,
        keyWords: '', // 卡片名称
        edition: '', // 客户端版本
        appId: '' // 应用id
      },
      Rowkey: '', // 所选表单行
      selectedRowKeys: [],
      showDetailModal: false,
      showAddModal: false,
      appList: [
        /*{id: '', displayName: '全部'}*/
      ], // App列表
      clientList: [{ value: '', label: '全部' }], // 客户端列表
      originClientList: [],
      cardInfo: {}
    }
  },
  computed: {
    rowSelection() {
      // 表格勾选事件
      const { selectedRowKeys }: any = this
      return {
        selectedRowKeys,
        onChange: (selectedRow: any) => {
          this.selectedRowKeys = selectedRow
        },
        getCheckboxProps(record) {
          return {
            style: {
              display: record.id ? 'block' : 'none'
            },
            props: {
              disabled: record.id ? false : true
            }
          }
        }
      }
    },
    canDelete() {
      return this.selectedRowKeys.length > 0
    },
    appInfo() {
      const { appList }: any = this
      return appList.find((item: any) => item.id === this.filter.appId)
    }
  },
  watch: {
    'filter.appId'(val) {
      this.showDetailModal = false
      this.getTableData('reload')
    },
    'filter.edition'(val) {
      this.showDetailModal = false
      this.getTableData('reload')
    },
    'filter.keyWords'(val) {
      this.showDetailModal = false
    }
  },
  created() {
    this.initial()
  },
  methods: {
    cancelChooseArr(val) {
      this.selectedRowKeys = [];
    },
    // 初始化各项
    initial() {
      this.filter.current = 1
      this.filter.keyWords = ''
      this.filter.edition = ''
      this.filter.appId = ''
      this.selectedRowKeys = []
      this.appList = []
      this.clientList = [{ value: '', label: '全部' }]
      this.originClientList = []
      this.loadSearchList()
    },
    // 获取搜索项列表数据
    loadSearchList() {
      Promise.all([
        dictService.dictionary('client_type'),
        appServiceProxy.page('', '', 1, '', 9999)
      ]).then((res) => {
        res[0].data.length &&
          res[0].data.map((client: any) => {
            client.label = client.dictValue
            client.value = client.dictKey
          })
        this.clientList = this.clientList.concat(res[0].data) || []
        this.originClientList = res[0].data || []
        this.appList = res[1].records || []
        /*处理下拉列表的数据以满足公共组件*/
        this.appList.map((app: any) => {
          app.label = app.displayName
          app.value = app.id
        })
        // 默认选择
        this.filter.appId = this.appList[0].id
      })
    },
    // 获取表格数据
    getTableData(reload?: any) {
      this.data = []
      this.loading = true
      this.showDetailModal = false
      if (reload) {
        // 从头加载
        this.filter.current = 1
        this.filter.size = 30
      }
      // this.data = []
      let { appId, current, edition, keyWords, size } = this.filter
      serviceProxy
        .page(appId, current, edition, keyWords, size)
        .then((res: any) => {
          // console.log('tabledata:', res)
          if (res) {
            this.data = res.records
            console.log(this.data,'data')
            this.totalContent = Number(res.total)
            if (this.data && this.data.length) {
              this.data.map((item: any) => {
                let editionItem = this.clientList.find(
                  (client) => Number(client.value) === item.edition
                )
                item.key = item.id
                console.log(item)
                item.editionName = editionItem ? editionItem.label : ''
              })
            }

            let dataLength = res.records.length
            let copy = JSON.parse(JSON.stringify(res.records))
            let needPush = 0
            if (dataLength < 30) {
              needPush = 30 - dataLength
              for (var k = 0; k < needPush; k++) {
                let obj = {
                  // id: 'none'
                }
                copy.push(obj)
              }
            }

            this.data = JSON.parse(JSON.stringify(copy))
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 表格行点击事件
    rowClick(record: any) {
      return {
        on: {
          click: (event: any) => {
            // console.log(record, 'record')
            this.showDetailModal = true
            this.Rowkey = record.key
            this.cardInfo = {}
            this.cardInfo = record
          }
        }
      }
    },
    handleEdit(record: any) {
      if (this.showDetailModal) {
        this.$confirm({
          title: this.$t('switch_tips_title'),
          content: this.$t('switch_tips_content'),
          onOk: () => {
            this.showDetailModal = true
            this.Rowkey = record.key
            this.cardInfo = {}
            this.cardInfo = record
          },
          onCancel() {
            return
          }
        })
      } else {
        this.showDetailModal = true
        this.Rowkey = record.key
        this.cardInfo = {}
        this.cardInfo = record
      }
    },
    // 换页
    pageIndexchange(current: any) {
      this.filter.current = current
      this.getTableData()
    },
    // 关闭新建卡片弹框
    closeAddCard(reload?: boolean) {
      this.showAddModal = false
      reload && this.getTableData(true)
    },
    // 关闭编辑卡片弹框
    closeEditCard(reload?: boolean) {
      this.showDetailModal = false
      reload && this.getTableData(true)
    },
    // 删除卡片
    handleDelete() {
      if (this.selectedRowKeys.length === 0) {
        this.$message.warning('请选择需要删除的卡片')
        return
      }
      serviceProxy
        .deleteCards(this.selectedRowKeys)
        .then((res: any) => {
          if (res) {
            this.$message.success('删除成功')
            this.getTableData('reload')
          } else {
            this.$message.error('删除失败')
          }
        })
        .catch((err: any) => {
          this.$message.error('删除失败')
        })
    }
  }
})
